import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { iClaseArticulo } from '../models/iclase-articulo.model';
import { iClaseCodigoArticulo } from '../models/iclase-codigo-articulo.model';
import { iClaseCodigoInterlocutor } from '../models/iclase-codigo-interlocutor.mode';
import { iClaseInterlocutor } from '../models/iclase-interlocutor.model';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class ClaseGenericaService {

    constructor(private apiService: ApiService) { }

    /****************************** ARTICULO ********************************/

    //CLASES
    insertar_clase_articulo(data: iClaseArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + '/articulo/clases');
        return this.apiService.executePostJson(data).pipe();
    }

    modificar_clase_articulo(data: iClaseArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + '/articulo/clases');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar_clase_articulo(tipinv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.executeDeleteJson(`/articulo/${tipinv}/clases/${clase}`)
    }

    obtener_clase_articulo(tipinv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/articulo/${tipinv}/clases/${clase}`)
    }

    busar_clase_articulo(tipinv: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/articulo/${tipinv}/clases`)
    }

    //CODIGO
    insertar_codigo_articulo(data: iClaseCodigoArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + '/articulo/clases/codigos');
        return this.apiService.executePostJson(data).pipe();
    }

    modificar_codigo_articulo(data: iClaseCodigoArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + '/articulo/clases/codigos');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar_codigo_articulo(tipinv: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.executeDeleteJson(`/articulo/${tipinv}/clases/${clase}/codigos/${codigo}`)
    }

    obtener_codigo_articulo(tipinv: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/articulo/${tipinv}/clases/${clase}/codigos/${codigo}`)
    }

    busar_codigo_articulo(tipinv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/articulo/${tipinv}/clases/${clase}/codigos`)
    }

        /****************************** CLIENTE ********************************/

    //CLASES
    insertar_clase_cliente(data: iClaseInterlocutor, tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + `/interlocutor-comercial/${tipcli}/clases`);
        return this.apiService.executePostJson(data).pipe();
    }

    modificar_clase_cliente(data: iClaseInterlocutor, tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + `/interlocutor-comercial/${tipcli}/clases`);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar_clase_cliente(tipcli: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.executeDeleteJson(`/interlocutor-comercial/${tipcli}/clases/${clase}`)
    }

    obtener_clase_cliente(tipcli: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/interlocutor-comercial/${tipcli}/clases/${clase}`)
    }

    busar_clase_cliente(tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/interlocutor-comercial/${tipcli}/clases`)
    }

    //CODIGO
    insertar_codigo_cliente(data: iClaseCodigoInterlocutor,tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + `/interlocutor-comercial/${tipcli}/clases/codigos`);
        return this.apiService.executePostJson(data).pipe();
    }

    modificar_codigo_cliente(data: iClaseCodigoInterlocutor, tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url + `/interlocutor-comercial/${tipcli}/clases/codigos`);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar_codigo_cliente(tipcli: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.executeDeleteJson(`/interlocutor-comercial/${tipcli}/clases/${clase}/codigos/${codigo}`)
    }

    obtener_codigo_cliente(tipcli: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/interlocutor-comercial/${tipcli}/clases/${clase}/codigos/${codigo}`)
    }

    busar_codigo_cliente(tipcli: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clases_genericas_CRUD_url);
        return this.apiService.execGetQueryJson(`/interlocutor-comercial/${tipcli}/clases/${clase}/codigos`)
    }
}